import { LogOut } from "lucide-react";

import { useGetAuthUser } from "@/api/get-user";
import { useLogout } from "@/api/logout";
import { Skeleton } from "@/components/ui/skeleton";

import { Avatar, AvatarFallback } from "./ui/avatar";
import { Button } from "./ui/button";

export function LogoutNavigationItem() {
  const { data: user, isPending, isSuccess } = useGetAuthUser();
  const { mutateAsync: logout, isPending: isLoggingOut } = useLogout();

  return (
    <div className="flex items-center gap-1 pb-4 pt-6">
      {isPending && (
        <div className="flex w-full items-center">
          <div>
            <Skeleton className="size-10 h-10 w-10 rounded-full bg-border" />
          </div>
          <div className="ml-2 w-full space-y-1">
            <Skeleton className="h-2 w-2/3 bg-border" />
            <Skeleton className="h-2 w-full bg-border" />
          </div>
        </div>
      )}
      {!isPending && isSuccess && (
        <div className="mr-3 flex min-w-0 flex-1 items-center gap-2">
          <Avatar>
            {/* <AvatarImage src="https://github.com/shadcn.png" /> */}
            <AvatarFallback className="bg-border text-muted">
              {user.given_name?.[0]}
              {user.family_name?.[0]}
            </AvatarFallback>
          </Avatar>
          <p className="flex min-w-0 flex-1 flex-col">
            <span className="block truncate text-left text-sm font-semibold text-secondary">
              {user.given_name} {user.family_name}
            </span>
            <span className="block truncate text-left text-xs font-normal text-muted">
              {user.email}
            </span>
          </p>
        </div>
      )}
      <div className="animate__animated animate__fadeIn ml-auto">
        <Button
          onClick={() => logout()}
          type="button"
          variant="ghost"
          className="text-muted"
          size="icon"
          isLoading={isLoggingOut}
          isAnimated
        >
          <LogOut aria-hidden="true" className="size-4" />
          <span className="sr-only">Log out</span>
        </Button>
      </div>
    </div>
  );
}
